import { render, staticRenderFns } from "./FabRegistroIncidencia.vue?vue&type=template&id=28b039da&scoped=true"
import script from "./FabRegistroIncidencia.vue?vue&type=script&lang=js"
export * from "./FabRegistroIncidencia.vue?vue&type=script&lang=js"
import style0 from "./FabRegistroIncidencia.vue?vue&type=style&index=0&id=28b039da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b039da",
  null
  
)

export default component.exports